// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3x5SX","content":"styles_content__3DY-Y","selectAll":"styles_selectAll__1gBCP"};